import { render, staticRenderFns } from "./notifications-smtp.vue?vue&type=template&id=4b0b7608&scoped=true"
import script from "./notifications-smtp.vue?vue&type=script&lang=ts"
export * from "./notifications-smtp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b7608",
  null
  
)

export default component.exports